export const FETCH_PROFILE_REQUEST = 'profile/FETCH_PROFILE_REQUEST'
export const FETCH_PROFILE_SUCCESS = 'profile/FETCH_PROFILE_SUCCESS'
export const FETCH_PROFILE_FAILURE = 'profile/FETCH_PROFILE_FAILURE'

export const UPDATE_PASSWORD_REQUEST = 'profile/UPDATE_PASSWORD_REQUEST'
export const UPDATE_PASSWORD_SUCCESS = 'profile/UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_FAILURE = 'profile/UPDATE_PASSWORD_FAILURE'

export const UPDATE_FIELD = 'profile/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'profile/SET_DEFAULT_DATA'
